export const toOption = x => ({
  ...x,
  value: x.id,
})

export const stringToOption = x => ({
  name: x,
  value: x,
})
